import portugueseConstant from "../config/portuguese-Constant";

export default class PortugueseQuoteApi {
  static getHeaders = (checkSandbox = false) => {
    let headers: any = {
      Accept: "application/json",
      "Content-Type": "application/json",
    };

    if (checkSandbox && portugueseConstant.isSandBoxMode) {
      headers["is-sandbox-mode"] = "1";
    }

    return headers;
  };

  static getHostCountries = async (productId: string) => {
    const response = await fetch(`${portugueseConstant.apiUrl}/product/${productId}/host-countries`, {
      headers: this.getHeaders(),
    });
    return response.json();
  };

  static getHostCountryPackages = async (productId: string, countryCode: string | null) => {
    const response = await fetch(`${portugueseConstant.apiUrl}/product/${productId}/country/${countryCode}/packages`, {
      headers: this.getHeaders(),
    });
    return response.json();
  };

  static getQuickQuote = async (data: any) => {
    const response = await fetch(`${portugueseConstant.apiUrl}/quote`, {
      method: "POST",
      body: JSON.stringify(data),
      headers: this.getHeaders(true),
    });
    return response.json();
  };

  static createOrder = async (data: any) => {
    const response = await fetch(`${portugueseConstant.apiUrl}/orders/condensed`, {
      method: "POST",
      body: JSON.stringify(data),
      headers: this.getHeaders(true),
    });
    return response.json();
  };

  static packageAmount = async (data: any) => {
    const response = await fetch(`${portugueseConstant.apiUrl}/quote/details/discounts`, {
      method: "POST",
      body: JSON.stringify(data),
      headers: this.getHeaders(),
    });
    return response.json();
  };

  static getPaymentIntent = async (orderId: string) => {
    const response = await fetch(`${portugueseConstant.apiUrl}/orders/${orderId}/payment/intent`, {
      headers: this.getHeaders(true),
    });
    return response.json();
  };

  static getPartnerLogo = async (partnerId: string) => {
    const response = await fetch(
      `https://api.battleface.com/api/v1/site/1/affiliate/getaffiliatecobranding/${partnerId}`,
      {
        headers: this.getHeaders(false),
      }
    );
    return response.json();
  };
}
